import * as Yup from 'yup';

import { httpDateFormat } from '../../../../utils/helpers/formatting';
import {
  yupMaxField,
  yupMinField,
  yupRequiredField,
} from '../../../../utils/helpers/yup';
import { HolidayType } from '../Holiday.functions';

export type CreateHoliday = {
  description: string;
  date: any;
};

export function getInitialValues(
  isEditDialog: boolean,
  holidayData: HolidayType | undefined
): CreateHoliday {
  return {
    description: isEditDialog ? holidayData?.description ?? '' : '',
    date: isEditDialog
      ? new Date(holidayData?.date as any) ?? new Date()
      : new Date(),
  };
}

export function getValidationSchema(t: any) {
  return Yup.object().shape({
    description: Yup.string()
      .required(yupRequiredField(t, t('Description')))
      .min(2, ({ min }) => yupMinField(t, t('Description'), min))
      .max(50, ({ max }) => yupMaxField(t, t('Description'), max)),
    date: Yup.date().required(yupRequiredField(t, t('Date'))),
  });
}

export function toApiData(values: CreateHoliday) {
  let apiData: CreateHoliday = {
    ...values,
  };

  apiData.description = values.description.trim();

  apiData.date = httpDateFormat(apiData.date as any);

  return apiData;
}
